var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChuyenCoPhieu = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E8E",
    d: "M.616 9.362c.17-.082.374-.058.521.062L7.1 14.275c.115.094.182.233.182.382 0 .148-.067.287-.182.381l-5.963 4.851c-.147.12-.35.145-.521.063-.172-.08-.281-.254-.281-.444V9.806c0-.19.11-.363.28-.444zm17.938.062c.147-.12.35-.144.521-.062.171.08.28.254.28.444v9.702c0 .19-.109.363-.28.444-.171.082-.374.057-.522-.062l-5.962-4.852c-.115-.094-.182-.233-.182-.381 0-.149.067-.288.182-.382zM9.845 7.01c.373 0 .675.302.675.675v10.708c0 .373-.302.675-.675.675-.373 0-.674-.302-.674-.675V7.684c0-.373.301-.675.674-.675zM3.071 2.415c3.925-3.22 9.623-3.22 13.548 0L17.53.764c.057-.103.17-.163.289-.15.118.013.217.096.251.21l1.609 5.474c.03.103.001.215-.075.29-.075.078-.187.106-.291.076l-5.474-1.609c-.115-.034-.197-.133-.21-.251-.013-.118.048-.233.15-.29l1.309-.72C12 1.441 7.69 1.441 4.602 3.793l1.308.72c.104.057.165.172.15.29-.012.118-.094.217-.21.251L.379 6.665c-.104.029-.216 0-.291-.076C.01 6.513-.018 6.4.012 6.298L1.62.823c.034-.113.132-.196.25-.209.118-.013.233.047.29.15z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChuyenCoPhieu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/_chuyen-co-phieu.3536b154.svg";
export { ForwardRef as ReactComponent };